function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5716 12.143V9.14294C12.5691 6.89536 10.7477 5.07395 8.50008 5.07147H6.3572C6.23885 5.07147 6.14291 4.97553 6.14291 4.85718V2.7143C6.37961 2.7143 6.57149 2.52242 6.57149 2.28573V1.42858C6.57149 1.19188 6.37961 1 6.14291 1H1.42858C1.19188 1 1 1.19188 1 1.42858V2.28573C1 2.52242 1.19188 2.7143 1.42858 2.7143V5.71434C1.43106 7.96192 3.25246 9.78333 5.50005 9.78581H7.64293C7.76128 9.78581 7.85722 9.88175 7.85722 10.0001V12.143C7.62052 12.143 7.42864 12.3349 7.42864 12.5716V13.4287C7.42864 13.6654 7.62052 13.8573 7.85722 13.8573H12.5716C12.8082 13.8573 13.0001 13.6654 13.0001 13.4287V12.5716C13.0001 12.3349 12.8082 12.143 12.5716 12.143ZM1.42858 1.42858H6.14291V2.28573H1.42858V1.42858ZM7.64293 9.35723H5.50005C3.48906 9.35499 1.8594 7.72532 1.85715 5.71434V2.7143H5.71434V4.85718C5.71434 5.21223 6.00216 5.50005 6.3572 5.50005H8.50008C10.5111 5.50229 12.1407 7.13196 12.143 9.14294V12.143H8.28579V10.0001C8.28579 9.64505 7.99797 9.35723 7.64293 9.35723ZM7.85722 13.4287V12.5716H12.5716V13.4287H7.85722Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.6
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.92857 4H3.07143C3.03198 4 3 4.22386 3 4.5C3 4.77614 3.03198 5 3.07143 5H3.92857C3.96802 5 4 4.77614 4 4.5C4 4.22386 3.96802 4 3.92857 4Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.92857 6H8.07143C8.03198 6 8 6.22386 8 6.5C8 6.77614 8.03198 7 8.07143 7H8.92857C8.96802 7 9 6.77614 9 6.5C9 6.22386 8.96802 6 8.92857 6Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.92857 10H9.07143C9.03198 10 9 10.2239 9 10.5C9 10.7761 9.03198 11 9.07143 11H9.92857C9.96802 11 10 10.7761 10 10.5C10 10.2239 9.96802 10 9.92857 10Z",
  fill: "currentColor"
});

function SvgHydroicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHydroicon);
export default __webpack_public_path__ + "static/media/hydro.icon.2bbc5087.svg";
export { ForwardRef as ReactComponent };